export default __webpack_public_path__ + "static/media/bz.32042460.svg";